<template>
  <!-- 派车运单明细 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList"
         ref="btnList">
      <div class="glo_btnList_left">
        <el-dropdown class="topDropDown"
                     @command="topCommandBtns">
          <el-button type="primary">
            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns :MoreConditions="MoreConditions"
                 @clerBtns="clerBtns"
                 @queryBtn_ok="queryBtn_ok"
                 @moreParam="moreParam"></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition ref="queryForm"
                    :More="isHaseMore"
                    :formConfig="queryCondditionDatas"></queryCondition>

    <!-- 表格 -->
    <mytable ref="myCarTable"
             :tableHeigth="tableHeigth"
             :tableData="tableData"
             :myTableHeard="myTableHeard"
             :isShowOperate="isShowOperate"
             :isShowMoreOperate="isShowMoreOperate"
             :btnsList="btnsList"
             :btnsMoreList="btnsMoreList"
             :Operatewidth="Operatewidth"
             @handleCommandBtns="handleCommandBtns"
             @handleSelectionChange="handleSelectionChange"></mytable>

    <!-- 分页 -->
    <paging ref="pags"
            :pageNum="pageStart"
            :total="pageCount"
            :size="pageTotal"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange">
    </paging>
    <!--        自定义表头           -->
    <sorttable :show_sortTableHeard="show_sortTableHeard"
               :allCheck="allCheck"
               :sortName="sortName"
               :tabelHeadeTitle="tabelHeadeTitle"
               :originalTabelHeadeTitle="originalTabelHeadeTitle"
               :selectLength="selectLength"
               @cancelSortHeard="cancelSortHeard"
               @confirmOk="confirmOk"
               @checktab="checktab"
               @checkAll="checkAll"
               @closeDias="closeDias">
    </sorttable>

  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import mytable from "@/components/table/table.vue";
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
import colorStatus from "@/assets/js/Mixins/colorStatus.js"; //导出的公共js
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew, exportjs, mixin_print, colorStatus],
  props: {
    dispatchType: {
      type: String,
      require: false,
      default: "shang_men_ti_huo",
    },
  },
  components: {
    sorttable,
    paging,
    multitime,
    myDialog,
    uploadimgs,
    queryBtns,
    mytable,
    queryCondition

  },
  data () {
    return {
      pageGroupName: "DeliveryOrderDetails", //  页面标识
      reportFiledsNumber: "admin_dispatch_command_info_list_v5", // 动态 条件、表头
      isShowOperate: false, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      Operatewidth: "220px", //操作列的列宽
      //  -----  查询  ------
      queryCondditionDatas: [
        {
          conditonKey: "dispatchType",
          conditonVal: this.dispatchType + ":dispatch_type",
        },
      ],


      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)

      fileNameLists: [], //上传组件的

    };
  },
  updated () { },
  created () { },
  activated () { },
  mounted () { },
  watch: {},
  methods: {
    handleSelectionChange (e) {
      // 表格选择事件
      // this.selectTableData = e;
    },
    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns (a) {
      if (a === "bgsz")
      {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dc")
      {
        // 导出
        this.exportBtn();
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn () {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    //点击更多操作下的按钮
    handleCommandBtns (type, val) {
      console.log(type);
      console.log(val);
    }
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
